// extracted by mini-css-extract-plugin
export default {"button":"CompanyUser_button__u4uOH","back":"CompanyUser_back__lCHR1"};